import { Routes, Route, useLocation } from 'react-router-dom';
import { Sidebar } from './components/Sidebar.jsx';
import { IconSprite } from './components/IconSprite.jsx';
import { DepartmentStatus } from './views/DepartmentStatus.jsx';
import { ExecutiveSummary } from './views/ExecutiveSummary.jsx';
import { CoverageRisk } from './views/CoverageRisk.jsx';
import { Manage } from './views/Manage.jsx';
import { Configure } from './views/Configure.jsx';
import { Analysis } from './views/Analysis.jsx';
import { Reports } from './views/Reports.jsx';
import { useModel } from './state.jsx';
import { useAuth, authDisabled } from './auth.jsx';

/** Page titles, keyed by route prefix — matches the legacy topbar. */
const TITLES = [
  ['/executive', 'Executive Summary'],
  ['/coverage', 'Coverage Risk'],
  ['/configure', 'Capacity Method & Inputs'],
  ['/manage/team', 'Team Roster'],
  ['/manage/outages', 'Known Outages'],
  ['/manage/pipeline', 'Anticipated Demand'],
  ['/manage/projects', 'Active Projects'],
  ['/manage/output', 'Team Output'],
  ['/manage/succession', 'Cascading Roles'],
  ['/analysis/decision', 'Hire / No-Hire'],
  ['/analysis/bizcase', 'Business Case'],
  ['/analysis/fragility', 'Team Fragility'],
  ['/analysis/compare', 'Scenario Compare'],
  ['/reports', 'Reports'],
];

function titleFor(pathname) {
  const hit = TITLES.find(([prefix]) => pathname.startsWith(prefix));
  return hit ? hit[1] : 'Department Status';
}

export function App() {
  const { isLoading, error, user } = useModel();
  const { signOut } = useAuth();
  const location = useLocation();

  if (error) {
    return (
      <div className="auth-screen">
        <div className="auth-card">
          <h2>Could not load the model</h2>
          <p>{error.message}</p>
        </div>
      </div>
    );
  }

  if (isLoading) return <div className="auth-screen">Loading the model…</div>;

  return (
    <>
      <IconSprite />
      <Sidebar />
      <div id="main">
        <header className="topbar">
          <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--ink)', letterSpacing: '-.2px' }}>
            {titleFor(location.pathname)}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginLeft: 'auto' }}>
            {user && (
              <span style={{ fontSize: 12, color: 'var(--ink3)' }}>
                {user.name}
                {user.roles?.length > 0 && ` · ${user.roles.join(', ')}`}
              </span>
            )}
            {!authDisabled && (
              <button className="btn btn-secondary btn-xs" onClick={signOut}>Sign out</button>
            )}
          </div>
        </header>

        <div className="content">
          <Routes>
            <Route path="/" element={<DepartmentStatus />} />
            <Route path="/executive" element={<ExecutiveSummary />} />
            <Route path="/coverage" element={<CoverageRisk />} />
            <Route path="/configure/:panel" element={<Configure />} />
            <Route path="/configure" element={<Configure />} />
            <Route path="/manage/:section" element={<Manage />} />
            <Route path="/manage" element={<Manage />} />
            <Route path="/analysis/:page" element={<Analysis />} />
            <Route path="/analysis" element={<Analysis />} />
            <Route path="/reports" element={<Reports />} />
          </Routes>
        </div>
      </div>
    </>
  );
}
